import React from "react";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { waLink } from "@/lib/api";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V7.69a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.12Z" />
  </svg>
);

export default function Footer({ siteInfo }) {
  const s = siteInfo || {};
  return (
    <footer className="bg-palumbo-black border-t border-white/10 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-10 bg-palumbo-copper flex items-center justify-center font-display font-black text-black text-xl">
                P
              </span>
              <div>
                <div className="font-display text-white font-extrabold uppercase tracking-tight">Palumbo</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-palumbo-copper">Custom Garage</div>
              </div>
            </div>
            <p className="text-neutral-400 max-w-md leading-relaxed">
              {s.footer_description || `${s.tagline || "Carrozzeria & Custom Garage"}. Carrozzeria, tuning estetico, verniciatura e restauro d'epoca.`}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-palumbo-copper mb-4">Contatti</h4>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="flex items-center gap-3"><Phone size={14} strokeWidth={1.5} /> {s.phone}</li>
              <li className="flex items-center gap-3"><Mail size={14} strokeWidth={1.5} /> {s.email}</li>
              <li className="flex items-center gap-3"><MapPin size={14} strokeWidth={1.5} /> {s.address}</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-palumbo-copper mb-4">Seguici</h4>
            <div className="flex gap-3">
              <a href={s.instagram} target="_blank" rel="noreferrer"
                data-testid="footer-instagram"
                className="w-11 h-11 border border-white/15 flex items-center justify-center text-white hover:bg-palumbo-copper hover:border-palumbo-copper transition-colors">
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a href={s.tiktok} target="_blank" rel="noreferrer"
                data-testid="footer-tiktok"
                className="w-11 h-11 border border-white/15 flex items-center justify-center text-white hover:bg-palumbo-copper hover:border-palumbo-copper transition-colors">
                <TikTokIcon className="w-[18px] h-[18px]" />
              </a>
              <a href={waLink(s.whatsapp)} target="_blank" rel="noreferrer"
                data-testid="footer-whatsapp"
                className="px-4 h-11 border border-palumbo-copper text-palumbo-copper hover:bg-palumbo-copper hover:text-white flex items-center font-bold uppercase tracking-widest text-xs transition-colors">
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-neutral-500 uppercase tracking-widest">
            © {new Date().getFullYear()} Palumbo Custom Garage. Tutti i diritti riservati.
          </p>
          <a href="/admin/login" data-testid="admin-link" className="text-xs text-neutral-600 hover:text-palumbo-copper uppercase tracking-widest">
            Area Riservata
          </a>
        </div>
      </div>

      <div className="font-display font-black text-[20vw] md:text-[14vw] uppercase tracking-tighter leading-none text-white/[0.03] select-none pointer-events-none text-center pb-4">
        Palumbo
      </div>
    </footer>
  );
}
